import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { SessionExpirationService } from '../session-expiration.service';
import { UserState } from '../../store/user/user.state';
import { SignOut } from '../../store/user/user.actions';

@Injectable({ providedIn: 'root' })
export class UnAuthGuard implements CanActivate {
  constructor(
    private store: Store,
    private router: Router,
    private sessionExpirationService: SessionExpirationService
  ) {}

  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (this.store.selectSnapshot(UserState.isAuthenticated)) {
      if (this.sessionExpirationService.isSessionAlreadyExpired()) {
        this.store.dispatch(new SignOut({ sessionExpired: true }));
        return true;
      }

      this.router.navigate(['/']);
      return false;
    }

    return true;
  }
}
